import { ReactNode, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getCertificateDetailsInfo } from '../api';
import { NonStructuredCertificateDetailsInfo } from '../types';

const {
  FetchProvider: CertificateDetailsInfoProvider,
  useFetch: useCertificateDetailsInfo,
} = createFetchContext<undefined, NonStructuredCertificateDetailsInfo>();

interface Props {
  children: ReactNode;
  fetchImmediately?: boolean;
}

export const CertificateDetailsInfoLoader = ({
  children,
  fetchImmediately = true,
}: Props) => {
  const { ceAcademicOfferId } = useParams<{ ceAcademicOfferId: string }>();

  const requestFn = useCallback(
    async () => getCertificateDetailsInfo(Number(ceAcademicOfferId)),
    [ceAcademicOfferId],
  );

  return (
    <CertificateDetailsInfoProvider
      request={requestFn}
      defaultQuery={undefined}
      fetchImmediately={fetchImmediately}
    >
      {children}
    </CertificateDetailsInfoProvider>
  );
};

export { useCertificateDetailsInfo };
